export default "__VITE_ASSET__BlGi7Qa6__"